import React, { Component } from 'react';
import 'moment/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';
import AddOrderRow from './AddOrderRow'
import OrderRow from './OrderRow'
import ErrorRow from './ErrorRow'
import PopUp from "../UI_Elements/Forms/PopUp";

class OrdersTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      errorVisible: false,
      errorMessage: '',
      showDelPopup:[]
    }

    this.showError = this.showError.bind(this)
    this.hideError = this.hideError.bind(this)
  }


  showError(e) {
    this.setState({
      errorVisible: true,
      errorMessage: e
    })
  }

  hideError() {
    this.setState({ errorVisible: false })
  }


  onRowDel(event,index){

      let showDelPopup = this.state.showDelPopup;
      showDelPopup[index] = true;
      this.setState({ showDelPopup:showDelPopup})
  }

  onRowDelCancel(event,index){
      let showDelPopup = this.state.showDelPopup;
      showDelPopup[index] = false;
      this.setState({ showDelPopup:showDelPopup })
  }



  deleteRow(event,index,order) {
      let showDelPopup = this.state.showDelPopup;
      showDelPopup[index] = false;
      this.setState({ showDelPopup:showDelPopup })
      this.props.onRowDel(order);
  }



  render() {

      var popups = this.props.orders.map((order, index) => {
          if (this.state.showDelPopup.length>0 && this.state.showDelPopup[index]===true){
              return (
                  <PopUp
                      key={index}
                      id={index}
                      object={order}
                      show={this.state.showDelPopup[index]}
                      title={"Vill du ta bort detta hjulset från ordern ?"}
                      onAccept={(event)=>this.deleteRow(event,index,order)}
                      onCancel={(event)=>this.onRowDelCancel(event,index)}
                  />
              )
          }
          return null;
      });
      var orders = this.props.orders.map((order, index) => {
          return (
                  <OrderRow
                      order={order}
                      onDelEvent={(event)=>this.onRowDel(event,index)}
                      key={index}
                      disabled={order.regnr.length >= 6 && order.serienr.length < 1}
                      errorVisible={this.state.errorVisible}                      
                  />
          )
      })
    
    return (
      <div>
        {popups}
        <table className="ordertable">
          <thead>
            <tr>
              <th>Regnr</th>
              <th>Serienr</th>
              <th>Bilmodell</th>
              <th>Hjulmodell</th>
              <th>Off rent date</th>
              <th>Last on rent</th>
            </tr>
          </thead>
          <tbody>
            {/* Rendera OrderRow om det finns orders */}
            {orders}

            { // Secondary order table
                this.props.tableType !== 'secondary' &&
            
                <AddOrderRow
                    disabled={this.props.orders.length >= 42 && true}
                    onValidData={this.props.onRowAdd}
                    addedOrders={this.props.orders}
                    showError={this.showError}
                    hideError={this.hideError}
                    updateOrderList={this.props.updateOrderList}
                    updateOrders={this.props.updateOrders}
                />
            }
            
                <ErrorRow
                  orders={this.props.orders}
                />
          </tbody>
        </table>

      </div>
    );
  }
}

export default OrdersTable


// WEBPACK FOOTER //
// ./src/components/Orders/OrdersTable.js